theme.lookbookSlider = (function () {
  function lookBook(e) {
    let slideshow = e.querySelector('.lookbook--slider'),
      paginationSelector = e.querySelector('.swiper-pagination'),
      navselectorPrev = e.querySelector('.swiper-button-prev'),
      navselectorNext = e.querySelector('.swiper-button-next')

    var lookbookSlider = new Swiper(slideshow, {
      loop: true,
      spaceBetween: 20,
      pagination: {
        el: paginationSelector,
        clickable: true,
      },
      autoplay: false,
      autoHeight: false,
      navigation: {
        nextEl: navselectorNext,
        prevEl: navselectorPrev,
      },
      breakpoints: {
        320: {
          slidesPerView: 2,
        },
        750: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 2,
        },
      },
    })

    // Lookbook hotspot connect
    const lookbookHotspot = e.querySelectorAll('.lookbook--product-hotspot')
    if (lookbookHotspot.length > 0) {
      lookbookHotspot.forEach((button) => {
        button?.addEventListener('mouseover', function (event) {
          lookbookSlider.slideToLoop(parseInt(button.dataset.index))
          slideshow.classList.add('lookbook__hover--active')
        })
        button?.addEventListener('mouseout', function (event) {
          slideshow.classList.remove('lookbook__hover--active')
        })
      })
    }

    if (lookbookHotspot.length > 0) {
      lookbookHotspot.forEach((button) => {
        button?.addEventListener('click', function (event) {
          lookbookSlider.slideToLoop(parseInt(button.dataset.index))
          slideshow.classList.add('lookbook__hover--active')
        })
      })
    }

    // Swiper loop clones slides via cloneNode — custom element constructors fire
    // before children are appended, so modal-opener's querySelector('button')
    // returns null and no click listener is attached. Reinit cloned openers.
    function initClonedModalOpeners() {
      e.querySelectorAll(
        '.swiper-slide-duplicate modal-opener:not([data-swiper-init])'
      ).forEach((opener) => {
        const button = opener.querySelector('button')
        if (!button) return
        opener.setAttribute('data-swiper-init', '')
        button.addEventListener('click', () => {
          const modal = document.querySelector(
            opener.getAttribute('data-modal')
          )
          if (modal) modal.show(button)
        })
      })
    }
    initClonedModalOpeners()
    lookbookSlider.on('loopFix', initClonedModalOpeners)

    // Active class
    lookbookSlider.on('slideChange', function () {
      const realIndex = lookbookSlider.realIndex
      if (lookbookHotspot.length > 0) {
        lookbookHotspot.forEach((button) => {
          button.classList.remove('active')
          if (parseInt(button.dataset.index) == realIndex) {
            button.classList.add('active')
          }
        })
      }
    })
  }
  return lookBook
})()
